import { Back } from 'icons';
import { rem } from 'polished';
import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

const BackButtonIcon = styled(Back).attrs(({ theme }) => ({
  primaryColor: theme.colors.text.secondary,
  secondaryColor: theme.colors.staticPalette.white,
}))`
  width: ${rem(50)};
  height: ${rem(50)};
  cursor: pointer;
`;

interface CourseNavigationButtonProps {
  navigateTo: string;
  ariaLabel: string;
}

export const CourseNavigationButton = ({
  navigateTo,
  ariaLabel,
}: CourseNavigationButtonProps) => {
  const history = useHistory();

  return (
    <BackButtonIcon
      role="button"
      tabIndex={0}
      aria-label={ariaLabel}
      onClick={() => {
        history.push(navigateTo);
      }}
      onKeyDown={e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          history.push(navigateTo);
        }
      }}
    />
  );
};
